// 请求失败后的统一拦截，以及ajax的基本设置
import axios from 'axios';
import qs from 'qs';
import Vue from 'vue';

axios.defaults.withCredentials = false;
axios.defaults.xsrfCookieName = null;
axios.defaults.headers['Access-Control-Allow-Headers'] = 'Origin, X-Requested-With, Content-Type, Accept, Connection, User-Agent, Cookie';
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

let publicPath = {
  // dev:'https://qa.knowbox.cn:8004',
  dev:'https://beta-bookerlisten.knowbox.cn',
  test: 'https://beta-bookerlisten.knowbox.cn',
  preview: 'https://pre-bookerlisten.knowbox.cn',
  production: 'https://bookerlisten.knowbox.cn',
};
axios.defaults.baseURL = publicPath[process.env.VUE_APP_INTER] || '/';

Vue.prototype.$http = axios;
Vue.http = axios;

// Add a response interceptor
axios.interceptors.response.use(
  function (response) {
    console.log(99,response)
    return response;
    //return Promise.resolve(response.data)
  },
  function (error) {
    return Promise.reject(error);
  }
);
export default axios;
